import { useState } from 'react'
import { ContainerDragAndDropImage } from './styles'
import { Text } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'

export function DragAndDrop({ control, multiple = false, name = 'files' }) {
  const [dragging, setDragging] = useState(false)

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field: { onChange, value } }) => (
        <ContainerDragAndDropImage
          onDragOver={(e) => {
            e.preventDefault()
            setDragging(true)
          }}
          onDragLeave={() => setDragging(false)}
          onDrop={(e) => {
            e.preventDefault()
            setDragging(false)
            const files = e.dataTransfer.files
            onChange(multiple ? files : files[0])
          }}
          dragging={dragging}
          htmlFor="files"
        >
          <input
            id="files"
            name="files"
            type="file"
            multiple={multiple}
            style={{ display: 'none' }}
            onChange={(e) => onChange(multiple ? e.target.files : e.target.files[0])}
          />
          {!value && (
            <Text fontSize="md" color="gray.600" textAlign="center" fontWeight="bold">
              {multiple
                ? 'Clique para selecionar arquivos, ou arraste e solte arquivos aqui.'
                : 'Clique para selecionar um arquivo, ou arraste e solte um arquivo aqui.'}
            </Text>
          )}
          {value && <p>{multiple ? `${value.length} arquivos selecionados` : value.name}</p>}
        </ContainerDragAndDropImage>
      )}
    />
  )
}
